import { createAPIEndPoint } from "./api";

// GET /login_logs/<user_id>  -> { logs: [...] }
export const fetchLoginLogsByUserId = async (userId) => {
  const res = await createAPIEndPoint(`login_logs/${userId}`).fetchAll();
  return res?.data?.logs || [];
};
